module.exports = __webpack_public_path__ + "media/customizations/tradition/back-03e76a761bbea15301e532205c7b6580.jpg";